import React from "react";
import { useOffline } from "../contexts/OfflineContext";
import { WifiOff, RefreshCw } from "lucide-react";

const OfflineIndicator: React.FC = () => {
  const { isOnline, syncPending, syncData } = useOffline();

  if (isOnline && !syncPending) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {!isOnline && (
        <div className="bg-orange-500 text-white px-4 py-2 text-center text-sm flex items-center justify-center gap-2">
          <WifiOff className="h-4 w-4" />
          <span>
            You're in offline mode. You can access cached data, but some
            features are unavailable.
          </span>
        </div>
      )}

      {isOnline && syncPending && (
        <div className="bg-blue-500 text-white px-4 py-2 text-center text-sm flex items-center justify-center gap-2">
          <RefreshCw className="h-4 w-4 animate-spin" />
          <span>Syncing pending changes...</span>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
